<template>
  <div>
    <SectionTitle class="my-2" :has-line="true" title="Información General" />

    <div class="row">
      <div class="col-12 col-md-4 pb-2 pb-md-0">
        <CustomDropDown
          v-model="value.academicYear"
          placeholder="Seleccione"
          fieldkey="id"
          fieldname="name"
          :options="collections.academicYears"
          label="Año Escolar:"
          disabled
        />
      </div>

      <div class="col-12 col-md-4 pb-2 pb-md-0">
        <CustomDatePicker
          v-model="today"
          format="dd/MMM./yyyy"
          label="Fecha:"
          disabled
          class="custom-datepicker"
        />
      </div>

      <div class="col-12 col-md-4 pb-2 pb-md-0">
        <ValidationProvider
          v-slot="{ errors }"
          :rules="isPhoneRequired ? 'required' : ''"
        >
          <CustomInput
            v-model="value.contactPhone"
            :label="contactPhoneLabel"
            :error="errors[0]"
            :custom-error-msg="'Favor escriba teléfono contacto.'"
            :disabled="isReadOnly"
            class="read-only"
            mask-type="Phone"
            placeholder="(__) __-____"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import CustomInput from 'CustomInput';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'GeneralInformation',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomDatePicker,
    CustomInput,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      required: true,
      default: false,
    },
    isPhoneRequired: {
      type: Boolean,
      default: true,
    },
    collections: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    contactPhoneLabel() {
      if (this.isMobile) {
        return 'Teléfono:';
      } else {
        return 'Teléfono contacto para solicitud:';
      }
    },
  },
  data: function() {
    return {
      today: null,
    };
  },
  mounted() {
    this.today = this.value.date ? this.value.date : new Date();
  },
};
</script>

<style scoped>
.custom-datepicker {
  width: 50%;
  margin: auto;
}

@media screen and (max-width: 480px) {
  .custom-datepicker {
    width: 100%;
  }

  .custom-datepicker >>> .custom-datetime-picker-container {
    width: 100% !important;
  }

  ::v-deep .tag-badge-title-info {
    font-size: 12px;
  }
}
</style>
